import React from "react"

import { ProductPositionFormClarificationRequest } from "./ProductPositionFormClarificationRequest"

export const ProductPositionFormClarificationRequestTab = React.memo(() => (
  <div className="product-position-form__tab-content product-position-form__tab-content--cr">
    <ProductPositionFormClarificationRequest />
  </div>
))
